import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centers-center',
  templateUrl: './centers-center.component.html',
  styleUrls: ['./centers-center.component.scss']
})
export class CentersCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
